import React from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import CssBaseline from '@material-ui/core/CssBaseline';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import '../Resources/Fonts/MontserratFont.js';

const theme = {
  palette: {
    primary: {
      main: '#8D8E92',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f44336',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['"Montserrat"', 'sans-serif'].join(', '),
    h3: {
      fontSize: '1.125rem',
    },
    body1: {
      fontSize: 'inherit',
    },
  },
  overrides: {
    palette: {
      primary: {
        main: '#8D8E92',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#f44336',
        contrastText: '#ffffff',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 0,
      },
    },
    MuiCssBaseline: {
      '@global': {
        html: {
          background: 'white',
        },
        '.frame': {
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
        },
      },
    },
  },
};

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    MuiCssBaseline: {
      '@global': {
        '.ccm-settings-summoner': {
          left: '0.5rem !important',
          bottom: '1rem !important',
          width: 24,
          height: 24,
          zIndex: 0,
          [theme.breakpoints.up('sm')]: {
            left: '1rem !important',
            bottom: '1rem !important',
            width: 48,
            height: 48,
          },
        },
      },
    },
  });
  merge(theme, {});
};

export default function ThemeProvider({ children }) {
  return (
    <ConnectedThemeProvider customTheme={theme} withTheme={overrideTheme}>
      <CssBaseline />
      {children}
    </ConnectedThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
